<template>
  <header :class="{'border-bottom': !type}">

    <template v-if="backButton">
      <smd-btn icon="smd-icon-arrow-left" @click="$emit('back')">
        <label v-if="backButtonLabel">{{backButtonLabel}}</label>
      </smd-btn>
    </template>
    <template v-if="actionMenu">
      <smd-btn class="action-menu" icon="smd-icon-action-menu" @click="$emit('menu')">
      </smd-btn>
    </template>

    <div class="smd-spacer" v-if="type == 'sub'"/>

    <h1 v-if="!type && title">{{title}}</h1>
    <h2 v-if="type == 'page' && title">{{title}}</h2>
    <h3 v-if="type == 'sub' || type == 'sub--left' && title">{{title}}</h3>

    <div class="smd-spacer" v-if="type == 'sub'"/>
    <slot name="top-label" />
    <slot/>

  </header>
</template>

<script>
  export default {
    name: "smd-titlebar",
    props:{
      actionMenu: {type: Boolean, default: false},
      backButton: {type: Boolean, default: false},
      backButtonLabel: String,
      title: String,
      type: String,
    }
  }
</script>

<style lang="scss">

  @import "scss/pogs-util";

  header{
    &.space-l{
      @include space-me(base, $flag: '!important');
    }

    &.space-s-l{
      @include space-me($t: s, $b: s, $r: base, $l: base, $flag: '!important');
    }

    &.space-m-b{
      @include space-me($b:m, $flag: '!important');
    }
  }

  .smd-spacer + h3{
    margin-left: -36px;
  }

</style>
